<script lang="ts">
  import { type StoresKey } from "~/stores";
  import type { CustomComponent } from "~/components/fragment-sets/custom-component";
  import Feedback from "~/components/fragment-sets/feedback/Feedback.svelte";
  import Button from "./Button.svelte";
  import CookiebotConsent from "~/components/fragment-sets/common/CookiebotConsent.svelte";

  export let request_store_key: StoresKey;
  export let fragment: Fragment;
  export let csrf_token: string;

  const submit_button: CustomComponent<Button> = {
    component: Button,
    props: {
      tag: "button",
    },
  };
  
</script>

<CookiebotConsent consent_category='marketing' {request_store_key}  {submit_button}>
  <Feedback 
    {request_store_key}
    {fragment}
    {csrf_token}
    {submit_button}
  />
</CookiebotConsent>